const indexPage = {
	allowSubmit: true
};

export default indexPage;
